import { getRadius } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconCopy } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { defaultFiltersParams } from "#app/routes/pages/Search.page";
import { colors } from "#app/theme/v2/colors";
import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { Box } from "#shared/view/components/Box";
import { DEFAULT_DIMENSION_WEIGHT } from "#shared/view/components/FilterButton";
import { Group } from "#shared/view/components/Group";
import { Text } from "#shared/view/components/Text";
import { FilterQuery } from "shared";

import { SimilarPartsModal } from "./SimilarPartsModal";

type Props = {
  quoteRequestLine: QuoteRequestLineDto;
};

export const ReliableChip = ({ quoteRequestLine }: Props) => {
  const { t } = useTranslation();
  const [opened, { open, close }] = useDisclosure(false);
  const [filtersParams, setFiltersParams] = useState<FilterQuery>(defaultFiltersParams);
  const [dimensionWeight, setDimensionWeight] = useState(DEFAULT_DIMENSION_WEIGHT);

  return (
    <>
      <Box
        size={12}
        variant="light"
        style={{
          borderRadius: getRadius("xs"),
          cursor: "pointer",
        }}
        onClick={open}
        bg={colors.bg.status.info.primary}
        px={6}
      >
        <Group gap="xxs">
          <IconCopy size={12} color={colors.text.info} />
          <Text fz={12} c={colors.text.info}>
            {t("qrl.prediction.reliable.label")}
          </Text>
        </Group>
      </Box>
      <SimilarPartsModal
        quoteRequestLine={quoteRequestLine}
        opened={opened}
        onClose={close}
        filtersParams={filtersParams}
        setFiltersParams={setFiltersParams}
        dimensionWeight={dimensionWeight}
        setDimensionWeight={setDimensionWeight}
      />
    </>
  );
};
